<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Revenue Summary</h3>
                    </div>
                    <div class="col-12 col-xl-4">

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row mb-3">
                     <div class="col-sm-4 col-md-6 col-6 stretch-card col-grid"></div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterRevenue" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                    
                </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                                             <div id="data-head" class="text-center">
                   <h4>{{ this.heading }}</h4>
                </div>

                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                        <th> Branch name</th>
                                        <th> Packages </th>
                                        <th> Ave/pack </th>
                                        <th> Total rev </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                                <td class="text-capitalize">{{parcel.name}}</td>
                                        <td class="text-capitalize"> <PriceFormat :Price="parcel.packages"/> </td>
                                        <td><label class="badge badge-success">Tsh <PriceFormat :Price="parcel.average"/></label></td>
                                        <td><label class="badge badge-primary">Tsh <PriceFormat :Price="parcel.revenue"/></label></td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>

<div class="mt-4">
                            <h4><u>Summary</u></h4>
                        </div>
                        <h5>Total Packages : <PriceFormat :Price="packs"/></h5>
                        <h5>Average price/pack Tsh: <PriceFormat :Price="avg"/>/=</h5>
                        <h5>Total Income Tsh: <PriceFormat :Price="rev"/>/=</h5>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            heading:"To Day's Revenue's From All Branches",
            fdate:"",
            tdate:"",
            packs:0, 
            rev:0,
            avg:0,
            parcels:[],
            og_parcels:[],
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async filterRevenue(){

             this.loading = true

          var fdate = this.fdate
          var tdate = this.tdate

          var response = await axios
              .post(this.$store.state.api_url + "/filter-revenue", {fdate, tdate})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.avg = response.data.avg;
                this.rev = response.data.rev;
                this.packs = response.data.packs;
                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

                this.heading = "Revenue From "+fdate+" To "+tdate
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        async getRevenue() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/revenue-report")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                //packs, rev, avg
                this.avg = response.data.avg;
                this.rev = response.data.rev;
                this.packs = response.data.packs;
                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

               /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },
       
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getRevenue()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
